import { render, staticRenderFns } from "./spots-list.vue?vue&type=template&id=03fe353c&"
import script from "./spots-list.vue?vue&type=script&lang=js&"
export * from "./spots-list.vue?vue&type=script&lang=js&"
import style0 from "./spots-list.vue?vue&type=style&index=0&id=03fe353c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports